import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Briefcase, BarChart3, FolderKanban, TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DashboardOverview = () => {
  const [stats, setStats] = useState({
    services: 0,
    projects: 0,
    statistics: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [services, projects, statistics] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/cms/services`),
        axios.get(`${BACKEND_URL}/api/cms/projects`),
        axios.get(`${BACKEND_URL}/api/cms/stats`)
      ]);

      setStats({
        services: services.data.length,
        projects: projects.data.length,
        statistics: statistics.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const cards = [
    { icon: Briefcase, label: 'Services', count: stats.services, color: 'bg-blue-500' },
    { icon: FolderKanban, label: 'Projects', count: stats.projects, color: 'bg-green-500' },
    { icon: BarChart3, label: 'Statistics', count: stats.statistics, color: 'bg-purple-500' },
    { icon: TrendingUp, label: 'Total Items', count: stats.services + stats.projects + stats.statistics, color: 'bg-[#0A1A50]' },
  ];

  return (
    <div>
      <h1 className="text-3xl font-light text-[#2d2d2d] mb-8">Dashboard Overview</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[#2d2d2d] font-light text-sm">{card.label}</p>
                <p className="text-3xl font-light text-[#2d2d2d] mt-2">{card.count}</p>
              </div>
              <div className={`w-12 h-12 ${card.color} rounded-lg flex items-center justify-center`}>
                <card.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-2xl font-light text-[#2d2d2d] mb-4">Quick Actions</h2>
        <p className="text-[#2d2d2d] font-light">
          Use the sidebar to navigate to different sections and manage your website content.
          All changes are saved to the database immediately.
        </p>
      </div>
    </div>
  );
};

export default DashboardOverview;